const registerPlumberBasePath = '/register/plumber';
const registerPlumberSteps = [
  {
    label: 'Company Details',
    path: `${registerPlumberBasePath}/1`,
  },
  {
    label: 'Voting Member Details',
    path: `${registerPlumberBasePath}/2`,
  },
  {
    label: 'Licences & Insurance',
    path: `${registerPlumberBasePath}/3`,
  },
  {
    label: 'Additional Information',
    path: `${registerPlumberBasePath}/4`,
  },
  {
    label: 'Payment',
    path: `${registerPlumberBasePath}/payment`,
  },
  {
    label: 'Confirmation',
    path: `${registerPlumberBasePath}/completed`,
  },
];

const registerAssociateBasePath = '/register/associate';
const registerAssociateSteps = [
  {
    label: 'Company Details',
    path: `${registerAssociateBasePath}/1`,
  },
  {
    label: 'Additional Information',
    path: `${registerAssociateBasePath}/2`,
  },
  {
    label: 'Payment',
    path: `${registerAssociateBasePath}/payment`,
  },
  {
    label: 'Confirmation',
    path: `${registerAssociateBasePath}/completed`,
  },
];

const registerRetiredBasePath = '/register/retired';
const registerRetiredSteps = [
  {
    label: 'Personal Details',
    path: `${registerRetiredBasePath}/1`,
  },
  {
    label: 'Voting Member Details',
    path: `${registerRetiredBasePath}/2`,
  },
  {
    label: 'Additional Information',
    path: `${registerRetiredBasePath}/3`,
  },
  {
    label: 'Payment',
    path: `${registerRetiredBasePath}/payment`,
  },
  {
    label: 'Confirmation',
    path: `${registerRetiredBasePath}/completed`,
  },
];

const registerTeacherBasePath = '/register/teacher';
const registerTeacherSteps = [
  {
    label: 'Company Details',
    path: `${registerTeacherBasePath}/1`,
  },
  {
    label: 'Additional Information',
    path: `${registerTeacherBasePath}/2`,
  },
  {
    label: 'Payment',
    path: `${registerTeacherBasePath}/payment`,
  },
  {
    label: 'Confirmation',
    path: `${registerTeacherBasePath}/completed`,
  },
];

const areaOfOperations = ['Residential Plumbing', 'Commercial Plumbing', 'Construction Plumbing'];

const trainingOrganisations = [
  'North Metropolitan TAFE - Balga',
  'South Metropolitan TAFE - Rockingham',
  'MPA Skills - Maylands',
  'South Regional TAFE - Bunbury',
  'South Regional TAFE - Albany',
  'Central Regional TAFE - Geraldton',
  'Other',
];

const howDidYouHearUs = ['Website', 'Word of mouth', 'Other Member', 'Social Media', 'Events', 'Google', 'Radio', 'Other'];

const insurers = [
  'AIG Insurance',
  'Allianz',
  'IAG',
  'Medibank Private',
  'QBE Insurance',
  'Suncorp',
  'TAL Life',
  'Youi Insurance',
  'Zurich',
  'Other',
];

const regions = [
  {
    name: 'All Metro',
    minPostcode: 6000,
    maxPostcode: 6210,
    subRegions: [
      {
        name: 'Perth City',
        minPostcode: 6000,
        maxPostcode: 6006,
      },
      {
        name: 'North West Metro',
        minPostcode: 6007,
        maxPostcode: 6049,
      },
      {
        name: 'North East Metro',
        minPostcode: 6050,
        maxPostcode: 6099,
      },
      {
        name: 'South East Metro',
        minPostcode: 6100,
        maxPostcode: 6149,
      },
      {
        name: 'South West Metro',
        minPostcode: 6150,
        maxPostcode: 6210,
      },
    ],
  },
  {
    name: 'All Country',
    minPostcode: 6211,
    maxPostcode: 6799,
    subRegions: [
      {
        name: 'South West Region',
        minPostcode: 6211,
        maxPostcode: 6299,
      },
      {
        name: 'Great Southern',
        minPostcode: 6300,
        maxPostcode: 6399,
      },
      {
        name: 'Central WA/Kalgoorlie',
        minPostcode: 6400,
        maxPostcode: 6444,
      },
      {
        name: 'Esperance',
        minPostcode: 6445,
        maxPostcode: 6452,
      },
      {
        name: 'Kalgoorlie',
        minPostcode: 6453,
        maxPostcode: 6699,
      },
      {
        name: 'Northern WA',
        minPostcode: 6700,
        maxPostcode: 6799,
      },
    ],
  },
  {
    name: 'PO Boxes Perth Metro',
    minPostcode: 6800,
    maxPostcode: 6997,
  },
];

const areas = [
  {
    name: 'metro',
    postcodeRanges: [
      {
        min: 6000,
        max: 6210,
      },
      {
        min: 6800,
        max: 6997,
      },
    ],
  },
  {
    name: 'regional',
    postcodeRanges: [
      {
        min: 6211,
        max: 6799,
      },
    ],
  },
];

export default {
  registerPlumberSteps,
  registerAssociateSteps,
  registerRetiredSteps,
  registerTeacherSteps,
  areaOfOperations,
  trainingOrganisations,
  howDidYouHearUs,
  insurers,
  regions,
  areas,
};
